var _path, _path2, _path3, _path4, _rect, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Gift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#cf1928",
    d: "M5,17v24c0,1.105,0.895,2,2,2h30V17H5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#b31523",
    d: "M37,17v26h5c1.105,0,2-0.895,2-2V17H37z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#eb6773",
    d: "M39,17v-6H4c-0.552,0-1,0.448-1,1v4c0,0.552,0.448,1,1,1H39z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#d9414f",
    d: "M39,11v6h6c0.552,0,1-0.448,1-1v-4c0-0.552-0.448-1-1-1H39z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 32,
    x: 19,
    y: 11,
    fill: "#edbe00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#e3a600",
    d: "M25,11h-8l-3.707-3.707c-0.391-0.391-0.391-1.024,0-1.414l2.586-2.586 c0.391-0.391,1.024-0.391,1.414,0L25,11z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#edbe00",
    d: "M22,11h8l3.707-3.707c0.391-0.391,0.391-1.024,0-1.414l-2.586-2.586 c-0.391-0.391-1.024-0.391-1.414,0L22,11z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Gift);
export default __webpack_public_path__ + "static/media/icons8-gift.b97312f2e1adddba97295322f0913824.svg";
export { ForwardRef as ReactComponent };